import React, { Component } from 'react';
import { HttpRequestService } from '../../services/HttpRequestService';
import FileInput from '../../common/FileInput';
import ShoppingCart from './ShoppingCart';
import { UtilsService } from '../../services/UtilsService';
import { DEFAULT_HOLD_REASONS } from '../../constants/Constants';
import DatePicker from "react-datepicker";
import moment from 'moment';
import StandardCommentSelect from '../../common/StandardCommentSelect';
import CompanySelect from '../../common/CompanySelect';
import AutoShipFrequencySelect from '../../common/AutoShipFrequencySelect';

class CreateMassOrder extends Component {
    constructor(props) {
        super(props);
        this.http = new HttpRequestService();
        this.state = {
            massOrderId: 0,
            accountsFile: null,
            order: null,
            holdReason: DEFAULT_HOLD_REASONS[0],
            otherHoldReason: "",
            orderNote: "",
            standardCommentId: -1,
            companyId: 2,
            autoShipFreq: "NoAutoShip",
            autoShipDuration: 0,
            autoShipStartDate: new Date()
        }
        this.handleAccountsFileChange = this.handleAccountsFileChange.bind(this);
        this.handleHoldReasonChange = this.handleHoldReasonChange.bind(this);
        this.handleHoldRelaseDateChange = this.handleHoldRelaseDateChange.bind(this);
        this.handleOtherHoldReasonChange = this.handleOtherHoldReasonChange.bind(this);
        this.handleCartItemAdded = this.handleCartItemAdded.bind(this);
        this.handleCompanyChange = this.handleCompanyChange.bind(this);
        this.handleStandardCommentChange = this.handleStandardCommentChange.bind(this);
        this.handleOrderNoteChange = this.handleOrderNoteChange.bind(this);
        this.handleAutoShipFreqChange = this.handleAutoShipFreqChange.bind(this);
        this.handleAutoShipDurationChange = this.handleAutoShipDurationChange.bind(this);
        this.handleAutoShipStartDateChange = this.handleAutoShipStartDateChange.bind(this);
        this.submit = this.submit.bind(this);
        this.utils = new UtilsService();
    }

    componentDidMount() {
        var massOrderId = this.props.match.params.id
        if (massOrderId) {
            this.setState({ massOrderId: massOrderId });
            this.getMassOrder(massOrderId);
        }
        else {
            this.createMockOrder();
        }
    }

    componentWillUnmount() {
        if (this.state.order && this.state.massOrderId === 0) {
            this.http.get("/api/Orders/DeleteMockOrder", { orderId: this.state.order.orderID });
        }
    }

    async createMockOrder() {
        const data = await this.http.get("/api/Orders/CreateMockOrder");
        this.setState({
            order: data
        });
    }

    getMassOrder(id) {
        this.http.get("/api/Order/GetMassOrder", { id: id }).then(data => {
            this.setState({
                holdReason: data.params.holdReason,
                otherHoldReason: data.params.otherHoldReason,
                holdReleaseDate: moment(data.params.holdReleaseDate).toDate(),
                autoShipFreq: data.params.autoShipFrequency,
                autoShipDuration: data.autoShipDuration,
                autoShipStartDate: moment(data.params.autoShipStartDate).toDate()
            }, () => {
                this.getOrder(data.sampleOrderID)
            });
        });
    }

    getOrder(id) {
        this.http.get("/api/Orders/GetOrder", { orderId: id }).then(data => {
            this.setState({
                order: data
            }, () => {
                const container = document.getElementById("mass-import");
                const allInputs = container.getElementsByTagName("*");
                for (let i = 0; i < allInputs.length; i++) {
                    allInputs[i].disabled = true;
                }
            });
        });
    }

    handleAccountsFileChange(file) {
        this.setState({
            accountsFile: file
        });
    }

    handleHoldReasonChange(e) {
        this.setState({
            holdReason: e.currentTarget.value
        });
    }

    handleHoldRelaseDateChange(value) {
        this.setState({
            holdReleaseDate: value
        });

    }

    handleOtherHoldReasonChange(e) {
        this.setState({
            otherHoldReason: e.currentTarget.value
        });
    }

    handleCartItemAdded(order) {
        this.setState({
            order: order
        });
    }

    handleOrderNoteChange(e) {
        this.setState({
            orderNote: e.target.value
        })
    }

    handleStandardCommentChange(standardComment) {
        this.setState({
            standardCommentId: standardComment
        });
    }

    handleCompanyChange(company) {
        this.setState({
            companyId: company
        });
    }

    handleAutoShipFreqChange(freq) {
        if (freq === "NoAutoShip") {
            this.setState({
                autoShipFreq: freq,
                autoShipDuration: 0
            });
        }
        else {
            this.setState({
                autoShipFreq: freq
            });
        }
    }

    handleAutoShipDurationChange(e) {
        this.setState({
            autoShipDuration: e.target.value
        });
    }

    handleAutoShipStartDateChange(date) {
        this.setState({
            autoShipStartDate: date
        });
    }

    submit() {
        var params = {
            model: JSON.stringify({
                companyId: this.state.companyId,
                standardCommentId: this.state.standardCommentId,
                orderNote: this.state.orderNote,
                orderId: this.state.order ? this.state.order.orderID : -1,
                holdReason: this.state.holdReason === "Other" ? this.state.otherHoldReason : this.state.holdReason,
                holdReleaseDate: this.state.holdReleaseDate,
                autoShipFreq: this.state.autoShipFreq,
                autoShipDuration: this.state.autoShipDuration,
                autoShipStartDate: this.state.autoShipStartDate
            }),
            operation: "MassCreateSampleOrders",
        }
        this.http.upload('/api/FileUpload/UploadFile/', this.state.accountsFile, params).then(() => {
            this.utils.info("It will take some time to import the accounts. You will receive an email once the process is complete.");
            this.setState({
                accountsFile: null,
                order: null,
                placeSampleOrders: false
            })
        });
    }

    render() {
        return (
            <div className="page-inner" id="mass-import">
                <div className="page-header">
                    <h4 className="page-title">Mass Create Sample Orders</h4>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card full-height">
                            <div className="card-body">
                                <div className="row m-0">
                                    <div className="form-group col-md-4">
                                        <label>Accounts File</label><br />
                                        <FileInput label="Select File" onChange={this.handleAccountsFileChange}></FileInput>
                                    </div>
                                    <div className="form-group col-md-4">
                                        <label>Standard Comment</label>
                                        <StandardCommentSelect value={this.state.standardCommentId} onChange={this.handleStandardCommentChange}></StandardCommentSelect>
                                    </div>
                                    <div className="form-group col-md-4">
                                        <label>Company</label>
                                        <CompanySelect value={this.state.companyId} onChange={this.handleCompanyChange}></CompanySelect>
                                    </div>
                                    <div className="form-group col-md-4">
                                        <label>On Hold Reason</label>
                                        <select className="form-control" value={this.state.holdReason} onChange={this.handleHoldReasonChange}>
                                            {DEFAULT_HOLD_REASONS.map(reason =>
                                                <option key={reason} value={reason}>{reason}</option>
                                            )}
                                            <option value="Other">Other</option>
                                        </select>
                                    </div>
                                    {this.state.holdReason === "Other" &&
                                        <div className="form-group col-md-4">
                                            <label>Other Reason</label>
                                            <input type="text" className="form-control" value={this.state.otherHoldReason} onChange={this.handleOtherHoldReasonChange}></input>
                                        </div>
                                    }
                                    <div className="form-group col-md-4">
                                        <label>Expected Release</label>
                                        <DatePicker className="form-control" selected={this.state.holdReleaseDate} onChange={this.handleHoldRelaseDateChange} />
                                    </div>
                                </div>
                                <div className="row m-0">
                                    <div className="form-group col-md-4">
                                        <label>Auto Ship Duration</label>
                                        <AutoShipFrequencySelect value={this.state.autoShipFreq} onChange={this.handleAutoShipFreqChange}></AutoShipFrequencySelect>
                                        <input type="text" disabled={this.state.autoShipFreq === "NoAutoShip"} value={this.state.autoShipDuration} onChange={this.handleAutoShipDurationChange} className="form-control" />
                                    </div>
                                    <div className="form-group col-md-4">
                                        <label>Auto Ship Starting Date</label>
                                        <DatePicker disabled={this.state.autoShipFreq === "NoAutoShip"} className="form-control" selected={this.state.autoShipStartDate} onChange={this.handleAutoShipStartDateChange} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.order &&
                    <React.Fragment>
                        <div className="row">
                            {/* Products */}
                            <div className="col-md-12">
                                <div className="card full-height">
                                    <div className="card-header">
                                        <div className="card-head-row">
                                            <div className="card-title">Products</div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        {this.state.order.shoppingCart != null &&
                                            <ShoppingCart order={this.state.order} shoppingCart={this.state.order.shoppingCart} onItemAdded={this.handleCartItemAdded}></ShoppingCart>
                                        }
                                    </div>
                                </div>
                            </div>
                            {/* End Products */}
                        </div>
                    </React.Fragment>
                }
                {this.state.massOrderId === 0 &&
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card full-height">
                                <div className="card-body pull-right">
                                    <button disabled={!this.state.accountsFile} className="btn btn-primary btn-default pull-right mr-2" onClick={this.submit}>Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default CreateMassOrder;
